/**
 * Demo Requests Service
 * Handles demo/lead requests submitted from the marketing landing page.
 */

import api from './api';

class DemoRequestsService {
  /**
   * Get demo requests with optional filters
   * @param {Object} filters - { page, limit, status }
   */
  async getDemoRequests(filters = {}) {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.status) params.append('status', filters.status);

    const response = await api.get(`/demo-request?${params.toString()}`);

    if (response.success && response.data) {
      return response.data;
    }

    throw new Error('Failed to fetch demo requests');
  }

  /**
   * Update a demo request's status
   * @param {string} id - Demo request ID
   * @param {string} status - New status ('New' | 'Contacted' | 'Closed')
   */
  async updateStatus(id, status) {
    const response = await api.patch(`/demo-request/${id}/status`, { status });

    if (response.success && response.data) {
      return response.data.demoRequest || response.data;
    }

    throw new Error('Failed to update status');
  }
}

const demoRequestsService = new DemoRequestsService();
export default demoRequestsService;
